import { render, staticRenderFns } from "./storyQA.vue?vue&type=template&id=0c6a5501&scoped=true"
import script from "./storyQA.vue?vue&type=script&lang=js"
export * from "./storyQA.vue?vue&type=script&lang=js"
import style0 from "./storyQA.vue?vue&type=style&index=0&id=0c6a5501&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a5501",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6a5501')) {
      api.createRecord('0c6a5501', component.options)
    } else {
      api.reload('0c6a5501', component.options)
    }
    module.hot.accept("./storyQA.vue?vue&type=template&id=0c6a5501&scoped=true", function () {
      api.rerender('0c6a5501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/list/storyQA.vue"
export default component.exports